export default __webpack_public_path__ + "150d6e27870641b261106fd229ce652e.png";